module.exports = __webpack_public_path__ + "img/ylb-en3.11be14f5.png";